<template>
  <header class="header-component">
    <DxToolbar class="header-toolbar">
      <DxItem :visible="menuToggleEnabled" location="before" css-class="menu-button">
        <template #default>
          <dx-button icon="menu" styling-mode="text" @click="toggleMenuFunc"/>
        </template>
      </DxItem>
      <DxItem :visible="!menuToggleEnabled" css-class="header-title dx-toolbar-label" location="before">
        <div class="header-title logo"><img :height="logoHeight" :width="logoWidth" :src="logoSmall"></div>
      </DxItem>
      <DxItem v-if="isDevelopScreen" location="after">
        <template #default>
          <DevelopLanguageSwitch/>
        </template>
      </DxItem>
      <DxItem location="after">
        <DxDropDownButton
            :items="userMenuItems"
            :drop-down-options="{ width: 210 }"
            :text="userIdent"
            styling-mode="text"
            icon="assets/user.svg"
            display-expr="name"
            key-expr="id"
            @item-click="onUserMenuClick"
        />
      </DxItem>
    </DxToolbar>
  </header>
  <DxPopup
      v-model:visible="hlpyNotificationVisible"
      :drag-enabled="false"
      :hide-on-outside-click="true"
      :show-close-button="true"
      :show-title="true"
      :width="360"
      :height="320"
      title="hlpy Benachrichtigung"
  >
    <DxForm id="hlpyForm" ref="hlpyForm" label-mode="floating" :form-data="hlpyConfigData" :col-count="1">
      <DxSimpleItem data-field="alert_callcenter_number"
                    :editor-options="{label: 'Rufnummer', showClearButton: true}"/>
      <DxSimpleItem data-field="from_date" editor-type="dxDateBox"
                    :editor-options="{label: 'Von Datum', type: 'datetime', displayFormat: 'dd.MM.yyyy HH:mm'}"/>
      <DxSimpleItem data-field="to_date" editor-type="dxDateBox"
                    :editor-options="{label: 'Bis Datum', type: 'datetime', displayFormat: 'dd.MM.yyyy HH:mm'}"/>
    </DxForm>
    <DxToolbarItem
        widget="dxButton"
        toolbar="bottom"
        location="center"
        :options="{text: formatMessage('btnSave')}"
        @click="onSaveHlpyConfig"
    />
    <DxToolbarItem
        widget="dxButton"
        toolbar="bottom"
        location="center"
        :options="{text: formatMessage('btnCancel')}"
        @click="hlpyNotificationVisible = false"
    />
  </DxPopup>
  <DxPopup
      v-model:visible="changePasswordVisible"
      :drag-enabled="false"
      :hide-on-outside-click="true"
      :show-close-button="true"
      :show-title="true"
      :width="320"
      :height="300"

      :title="formatMessage('cpChangePassword')"
  >
    <DxForm id="form" ref="form" label-mode="floating" :form-data="formData" :col-count="1">
      <DxSimpleItem data-field="pw" :is-required="true"
                    :editor-options="{label: formatMessage('cpNewPassword'), showClearButton: true, mode: 'password'}"/>
      <DxSimpleItem data-field="retypedPw" :is-required="true"
                    :editor-options="{label: formatMessage('cpRetypePassword'), showClearButton: true, mode: 'password'}"/>
    </DxForm>
    <DxToolbarItem
        widget="dxButton"
        toolbar="bottom"
        location="center"
        :options="{text: formatMessage('btnSave')}"
        @click="onChangePWClick"
    />
    <DxToolbarItem
        widget="dxButton"
        toolbar="bottom"
        location="center"
        :options="{text:  formatMessage('btnCancel')}"
        @click="onCancelClick"
    />
  </DxPopup>
</template>

<script>
import DxButton from "devextreme-vue/button";
import DevelopLanguageSwitch from "./develop/language-switch.vue";
import {isDevelopPath} from "../utils/develop-lang";
import DxToolbar, {DxItem} from "devextreme-vue/toolbar";
import auth from "../auth";
import appConfig from "../app-config";
import axios from "axios";
import {formatDate} from "devextreme/localization";
import {useRouter, useRoute} from 'vue-router';
import {DxDropDownButton} from "devextreme-vue";
import {confirm} from "devextreme/ui/dialog"
import {DxPopup, DxToolbarItem} from "devextreme-vue/popup";
import {DxForm, DxSimpleItem} from "devextreme-vue/form";
import {alert} from "devextreme/ui/dialog";
import {formatMessage} from "devextreme/localization";

export default {
  props: {
    menuToggleEnabled: Boolean,
    title: String,
    toggleMenuFunc: Function,
    logOutFunc: Function
  },

  data() {
    const router = useRouter();
    const route = useRoute();

    return {
      logoSmall: 'assets/brand/logo_empty.png',
      logoHeight: 29,
      logoWidth: 150,
      userIdent: auth._userIdent,
      changePasswordVisible: false,
      formData: {pw: '', retypedPw: ''},
      hlpyNotificationVisible: false,
      hlpyConfigData: {alert_callcenter_number: '', from_date: null, to_date: null},
      router,
      route
    };
  },

  computed: {
    isDevelopScreen() {
      return isDevelopPath(this.route.path);
    },
    userMenuItems() {
      const items = [
        {id: 1, name: formatMessage('btnLogout'), icon: 'assets/door_exit.svg'},
        {id: 2, name: formatMessage('btnChangePassword'), icon: 'assets/keys.svg'},
      ];
      if (appConfig.user_id === 25 || appConfig.user_id === 26 || appConfig.user_id === 27) {
        items.push({id: 3, name: 'hlpy Benachrichtigung', icon: 'assets/warning.svg'});
      }
      return items;
    }
  },

  async created() {
    let logoCfg = await import('@/logo.json');

    let brand = document.location.origin.substring(0, document.location.origin.indexOf('.')).substring(8);

    if (brand !== 'byd' || brand !== 'flaschenpost')
      brand = 'intern';
    // brand = 'flaschenpost';

    this.logoSmall = logoCfg[brand].logo;
    this.logoWidth = logoCfg[brand].width;
    this.logoHeight = logoCfg[brand].height;
  },

  methods: {
    formatMessage,
    async onUserMenuClick(e) {
      switch (e.itemData.id) {
        case 1:
          confirm(formatMessage('cpWantLogout'), 'Logout').then((dialogResult) => {
            if (dialogResult) {
              auth.logOut();
              this.router.push({
                path: "/authentication",
                query: {redirect: "/home"}
              });
            }
          });
          break;
        case 2:
          this.formData = {pw: '', retypedPw: ''}
          this.changePasswordVisible = true;
          break;
        case 3:
          await this.loadHlpyConfig();
          this.hlpyNotificationVisible = true;
          break;
      }
    },

    async loadHlpyConfig() {
      const headers = {
        'Authorization': 'Bearer ' + appConfig.session_token,
        'last-update-ts': formatDate(new Date(), 'yyyy-MM-dd HH:mm:ss')
      };
      const response = await axios.get(appConfig.host + 'config(1)', {headers});
      if (response.data) {
        const d = response.data;
        this.hlpyConfigData = {
          alert_callcenter_number: d.alert_callcenter_number || '',
          from_date: d.from_date ? new Date(d.from_date) : null,
          to_date: d.to_date ? new Date(d.to_date) : null,
        };
      }
    },

    async onSaveHlpyConfig() {
      const headers = {
        'Authorization': 'Bearer ' + appConfig.session_token,
        'last-update-ts': formatDate(new Date(), 'yyyy-MM-dd HH:mm:ss')
      };
      await axios.put(appConfig.host + 'config(1)', {
        alert_callcenter_number: this.hlpyConfigData.alert_callcenter_number,
        from_date: this.hlpyConfigData.from_date ? formatDate(this.hlpyConfigData.from_date, 'yyyy-MM-dd HH:mm:ss') : null,
        to_date: this.hlpyConfigData.to_date ? formatDate(this.hlpyConfigData.to_date, 'yyyy-MM-dd HH:mm:ss') : null,
      }, {headers});
      this.hlpyNotificationVisible = false;
    },

    onChangePWClick: async function () {
      const {pw, retypedPw} = this.formData;
      const validationResult = this.$refs.form.instance.validate();

      if (validationResult.isValid) {

        if (pw === retypedPw) {
          const result = await auth.changePw(pw);
          await alert(result.isOk ? formatMessage('msgPassWordChangeSuccess') : formatMessage('msgPassWordChangeFailed'), formatMessage('cpInformation'));
          this.changePasswordVisible = false;
          return;
        } else
          await alert(formatMessage('msgRepetitionWrong'), formatMessage('cpInformation'));
        return;
      }
      await alert(formatMessage('msgCheckInput'), formatMessage('cpInformation'));
    },

    onCancelClick() {
      this.changePasswordVisible = false;
    }
  },

  components: {
    DxButton,
    DevelopLanguageSwitch,
    DxToolbar,
    DxItem,
    DxDropDownButton,
    DxToolbarItem,
    DxPopup,
    DxForm,
    DxSimpleItem
  }
};
</script>

<style lang="scss">
@import "../themes/generated/variables.base.scss";
@import "../dx-styles.scss";

.header-component {
  flex: 0 0 auto;
  z-index: 1;
  box-shadow: 0 1px 1px rgba(0, 0, 0, 0.12), 0 1px 0 rgba(0, 0, 0, 0.24);

  .dx-toolbar .dx-toolbar-item.menu-button > .dx-toolbar-item-content .dx-icon {
    color: $base-accent;
  }
}

.dx-toolbar.header-toolbar .dx-toolbar-items-container .dx-toolbar-after {
  padding: 0 20px;

  .screen-x-small & {
    padding: 0 20px;
  }
}

.dx-toolbar .dx-toolbar-item.dx-toolbar-button.menu-button {
  width: $side-panel-min-width;
  text-align: center;
  padding: 0;
}

.header-title .DxItem-content {
  padding: 0;
  margin: 0;
}

.header-title .logo {
  padding-left: 15px;
  padding-top: 2px;
}
</style>
